<template>
</template>

<script lang="ts" setup>
definePage({
  meta: {
    hidden: true,
    local: true,
    isLayout: true,
    authorize: [],
  },
  redirect: '/login/',
})
</script>
